import { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext();

export function useToast() {
  return useContext(ToastContext);
}

let toastId = 0;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'info') => {
    const id = ++toastId;
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, 3000);
  }, []);

  const success = useCallback((msg) => addToast(msg, 'success'), [addToast]);
  const error = useCallback((msg) => addToast(msg, 'error'), [addToast]);
  const info = useCallback((msg) => addToast(msg, 'info'), [addToast]);

  const colors = {
    success: { bg: '#151230', border: '#4ade80', color: '#4ade80' },
    error: { bg: '#151230', border: '#f87171', color: '#f87171' },
    info: { bg: '#151230', border: '#7c3aed', color: '#a78bfa' },
  };

  return (
    <ToastContext.Provider value={{ success, error, info }}>
      {children}
      <div style={{ position: 'fixed', bottom: 24, right: 24, zIndex: 50, display: 'flex', flexDirection: 'column', gap: 8 }}>
        {toasts.map((t) => {
          const c = colors[t.type] || colors.info;
          return (
            <div key={t.id} className="animate-slide-in-right"
              style={{ background: c.bg, border: `1px solid ${c.border}`, color: c.color, padding: '12px 20px', borderRadius: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.4)', fontFamily: "'DM Sans',sans-serif", fontSize: '0.85rem', fontWeight: 500, minWidth: 260, maxWidth: 380 }}>
              {t.message}
            </div>
          );
        })}
      </div>
    </ToastContext.Provider>
  );
}
